import { createMuiTheme as createTheme /** FIXME MUI update */ } from '@material-ui/core/styles'
import { Colors } from '../consts'

// theme instance.
export const customTheme = createTheme({
  typography: {
    fontSize: 15,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
      fontSize: '1.4rem',
      lineHeight: 1,
      letterSpacing: '0.0075em'
    },
    h2: {
      fontWeight: 600,
      fontSize: '1.4rem',
      lineHeight: 2,
      letterSpacing: '0.0075em'
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: 1.4,
      letterSpacing: '0.0075em'
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.15rem',
      lineHeight: 1.2,
      letterSpacing: '0.0075em'
    },
    h5: {
      fontWeight: 500,
      fontSize: '1rem',
      lineHeight: 1.1,
      letterSpacing: '0.0075em'
    },
    button: {
      textTransform: 'none'
    }
  },
  palette: {
    primary: Colors.Primary,
    secondary: Colors.Secondary,
    error: {
      main: Colors.Error
    },
    background: {
      default: Colors.Background.Default
    }
  },
  overrides: {
    MuiChip: {
      label: {
        whiteSpace: 'normal',
        wordBreak: 'break-all'
      },
      sizeSmall: {
        height: 'auto',
        minHeight: '24px'
      },
      outlined: {
        backgroundColor: '#ffffffdd'
      }
    },
    MuiBadge: {
      anchorOriginBottomRightRectangle: {
        right: '4px',
        bottom: '4px'
      }
    }
  }
})
